<template>
  <div class="pt-4 p-6">
    <h1 class="text-2xl font-semibold text-gray-07 mb-6">
      Histórico de Avisos
    </h1>
    <router-view />
  </div>
</template>
